export default () => {
  document.addEventListener('click', (event) => {
    if (event.target.closest('input[type="submit"][value="Join"]')) {
      window.localStorage.setItem('creating-new-account', 'true');
    }

    if (event.target.closest('input[type="submit"]:not([value="Join"])')) {
      window.localStorage.removeItem('creating-new-account');
    }
  });

  if (document.querySelector('.template-register-success')) {
    window.localStorage.removeItem('creating-new-account');
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-speech-bubble]')) {
      const speechBubbles = document.querySelectorAll('[data-speech-bubble]');
      speechBubbles.forEach((bubble) => bubble.classList.remove('revealed'));
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-speech-bubble-toggle]')) {
      event.preventDefault();
      event.stopPropagation();

      const speechBubble = event.target.querySelector('[data-speech-bubble]');
      if (speechBubble) {
        speechBubble.classList.toggle('revealed');
      }
    }
  });
};
